const es = {
  headerComponent: {
    home: "Inicio",
    aboutUs: "Sobre Nosotros",
    plans: "Planes",
    contact: "Contacto",
    login: "Iniciar Sesión",
    register: "Crear Cuenta",
    adm: {
      priceList: "Lista de Precios",
      reservations: "Reservas",
      users: "Usuarios",
    },
    isntMobile: {
      isStoreOwner: {
        reservations: "Reservas",
        property: "Propiedad",
        subscription: "Suscripción",
      },
      isAuthenticated: {
        settings: "Configuración",
        explanatoryVideos: "Videos Explicativos",
        logOut: "Cerrar Sesión",
      },
    },
  },

  login: {
    welcomeBack: "¡Bienvenido de nuevo!",
    text: "Inicia sesión para acceder a tu cuenta y seguir disfrutando de todos los beneficios que ofrecemos. ¡Es rápido y fácil, y estamos aquí para ayudarte si lo necesitas!",
    password: "Contraseña",
    submit: "Iniciar sesión",
    forgotPassword: "¿Ha olvidado tu contraseña?",
    error: {
      email: "El correo electrónico es obligatorio",
      password: "La contraseña es obligatoria",
      login: "Error al iniciar sesión:",
    },
  },

  plans: {
    defaultErrorMessage: "Error al obtener la lista de precios",
    errorAlert:
      "No se han encontrado mesas todavía. Por favor, inténtalo de nuevo.",
    pageName: "Planes",
    title: "Encuentra el plan perfecto para ti",
    you: "ti.",
    text: "Ajusta el control deslizante a continuación para indicar tu número de propiedades.",
    selectedProperties: "Propiedades seleccionadas",
    selectedProperty_1: "Propiedad seleccionada",
    perfectForYou: "Perfecto para ti",
    month: "mes",
    perProperty: "Por propiedad en este tramo",
    planFor: "Plan para ",
    to: "a ",
    properties: " propiedades",
    continue: "Continuar",
    tiersNotice:
      "El cobro es progresivo: el precio de cada tramo se aplica a las propiedades que entran en ese tramo, y los tramos se suman para formar tu mensualidad.",
    monthlyTotal: "Tu mensualidad",
    averagePerProperty: "Equivale a {price} por propiedad",
    breakdownTitle: "Cómo llegamos a este importe",
    propertySingle: "Propiedad {n}",
    propertyRange: "Propiedades {from} a {to}",
    fromPropertyOnwards: "{from} propiedades o más",
    quoteError: "No fue posible calcular la mensualidad. Inténtalo de nuevo.",
  },

  register: {
    createAccount: "Crear Cuenta",
    welcome: "¡Bienvenido a Selfie Check-in!",
    welcomeMessage:
      "Estamos emocionados de tenerte con nosotros. Crear tu cuenta es rápido y fácil: ¡completa los campos a continuación y nuestro consultor se pondrá en contacto contigo!",
    yourData: "Tu Información",
    name: "Nombre",
    fullNameRequired: "Se requiere el nombre completo",
    email: "Correo electrónico",
    emailRequired: "Se requiere correo electrónico",
    invalidEmail: "Correo electrónico inválido",
    phone: "Teléfono (WhatsApp)",
    phoneRequired: "Se requiere teléfono",
    invalidPhone: "Teléfono inválido",
    companyName: "Nombre de la empresa",
    companyNameRequired: "Se requiere nombre de la empresa",
    cnpj: "CNPJ",
    website: "Sitio web",
    invalidWebsite: "Sitio web inválido",
    cnpjRequired: "Se requiere CNPJ",
    createPassword: "Crear una contraseña",
    passwordRequired: "Se requiere contraseña",
    confirmPassword: "Confirma tu contraseña",
    confirmPasswordRequired: "Se requiere confirmación de contraseña",
    emailRegistered: "Correo electrónico ya registrado",
    minPasswordLength: "La contraseña debe tener al menos 6 caracteres",
    passwordMismatch: "Las contraseñas deben coincidir",
    quantityRequired: "Se requiere cantidad",
    quantityMustBeNumber: "La cantidad debe ser un número",
    minQuantity: "Minimo de 1 propiedad",
    maxQuantity: "Maximo de 1000 propiedades",
    skipSubscription: "No deseo suscribirme ahora",
    back: "Atrás",
    finishRegister: "Completar Registro",
  },

  aboutUs: {
    title: "SOBRE NOSOTROS",
    subtitleSpan: "Revolucionamos tu ",
    subtitle: "experiencia de hospedaje",
    text: "Inyectando innovación y seguridad en cada paso. Con tecnología de punta y un toque práctico, hacemos que cada estancia sea más segura, rápida y confiable.",
    connected: {
      title: "Conectado",
      textBrLeft: "Integrado con las principales",
      textBrRight: "plataformas de hospedaje.",
    },
    secure: {
      title: "Seguro",
      text: "Todos los datos se autentican directamente a través de Gov.br, garantizando tranquilidad.",
    },
    userFriendly: {
      title: "Fácil de usar",
      text: "Diseñado para la comodidad tanto tuya como de tus huéspedes.",
    },
    content1: {
      title:
        "Nacido de los desafíos reales que enfrentan los anfitriones de alquileres vacacionales,",
      text: "Selfie Check-in aborda la necesidad de una combinación perfecta entre procesos de reserva eficientes y experiencias rápidas y fáciles para los huéspedes.",
    },
    content2: {
      title: "Entendiendo que la seguridad de la propiedad es primordial,",
      text: "desarrollamos un software que verifica cruzadamente la información y los documentos, asegurando la autenticidad de los datos de manera simple y eficiente.",
    },
    caption:
      "¡Optimizamos tu proceso de reserva para ofrecer la experiencia fluida y eficaz que tú y tus huéspedes merecen!",
  },

  contact: {
    contact: "Contacto",
    title: "Ponte en contacto con nosotros",
    caption:
      "Estamos aquí para ayudarte y responder tus preguntas. Completa el formulario a continuación o envíanos un mensaje directo.",
    fields: {
      name: "Nombre",
      email: "Correo electrónico",
      phone: "Teléfono (WhatsApp)",
      subject: "Asunto",
      message: "Tu mensaje",
      submit: "Enviar mensaje",
    },
    text: "Optimizamos tu proceso de reserva para brindarte a ti y a tus huéspedes una experiencia fluida y eficiente.",
    validation: {
      name: "El nombre es obligatorio",
      email: {
        required: "El correo electrónico es obligatorio",
        invalid: "Dirección de correo electrónico inválida",
      },
      phone: "El teléfono es obligatorio",
      subject: "El asunto es obligatorio",
      message: "El mensaje es obligatorio",
    },
    hubspotForm: {
      fields: {
        firstname: "Nombre",
        companyName: "Nombre de la empresa",
        email: "Correo electrónico",
        phone: "Teléfono",
        propertiesCount: "¿Cuántas propiedades/habitaciones administra?",
        usesChannelManager: "¿Usa channel manager?",
        whichChannelManager: "Si es así, ¿cuál?",
        submit: "Enviar",
      },
      options: {
        yes: "Sí",
        no: "No",
        other: "Otro",
      },
      validation: {
        firstname: "Informe su nombre",
        companyName: "Informe el nombre de la empresa",
        email: {
          required: "Informe el correo electrónico",
          invalid: "Informe un correo electrónico válido",
        },
        phone: "Informe el teléfono",
        propertiesCount: "Informe cuántas propiedades/habitaciones administra",
        channelManagerUsage: "Informe si usa channel manager",
        whichChannelManager: "Informe qué channel manager usa",
      },
    },
    success: "¡Formulario enviado con éxito!",
    captcha: {
      required: "Confirma que no eres un robot.",
      unavailable: "El captcha no está configurado en este momento.",
    },
    error: {
      generic: "Error al enviar el formulario",
    },
  },

  fetchWrapper: {
    notConnectServer:
      "No se pudo conectar con el servidor. Por favor, inténtalo más tarde.",
    internalServerError:
      "Ha ocurrido un error interno del servidor. Por favor, inténtalo más tarde.",
  },

  footerComponent: {
    title: "¡No pierdas tiempo! Elimina los trámites burocráticos.",
    freeTrialLink: "Prueba 30 Días Gratis",
    contact: "Contacto",
    allRights: "Todos los derechos reservados",
  },

  reload: "Recargar",
  towHours: "Este campo será visible 2 horas antes del check-in.",
  edit: "Editar",
  create: "Crear",
  stay: "Estancia",
  yourStay: "Tu Estancia",
  welcome: "Bienvenido",
  addressD: "Dirección",
  earlyCheck: "Check-in temprano",
  reqLate: "Solicitar check-out tardío",
  mobCheck: "Check-out móvil",
  rebook: "Reserva directa y ahorra",
  homeGuide: "Guía de la casa",
  homeD: "Tour por la casa",
  inventory: "Inventario/Kits de inicio",
  coffeM: "Máquinas de café",
  tv: "Instrucciones del televisor",
  freezer: "Nevera/Congelador",
  cooling: "Calefacción y refrigeración",
  laundry: "Lavandería",
  trash: "Basura",
  pool: "Piscina",
  hotTub: "Jacuzzi",
  doorCode: "Código de la puerta",
  areaGuide: "Guía de la zona",
  clearSky: "Cielo despejado",
  mainlyClear: "Principalmente despejado",
  partlyCloudy: "Parcialmente nublado",
  overcast: "Nublado",
  fog: "Niebla",
  drizzle: "Llovizna",
  freezingDrizzle: "Llovizna helada",
  rain: "Lluvia",
  freezingRain: "Lluvia helada",
  snow: "Nieve",
  snowGrains: "Granos de nieve",
  rainShowers: "Chubascos de lluvia",
  snowShowers: "Chubascos de nieve",
  thunderstorm: "Tormenta eléctrica",
  thunderstormHail: "Tormenta eléctrica con granizo",
  unknown: "Desconocido",
  weatherLoading: "Obteniendo datos del pronóstico del tiempo...",
  weatherError: "No se pudo obtener el pronóstico del tiempo.",

  nearBy: {
    mapUpdated: "Mapa actualizado a la ubicación seleccionada",
    addressCopied: "¡Dirección copiada con éxito!",
    restaurant: "Restaurante",
    bar: "Bar",
    market: "Mercado",
    bakery: "Panadería",
    pharmacy: "Farmacia",
    mall: "Centro comercial",
    bank: "Banco",
    theater: "Teatro",
    cinema: "Cine",
    museum: "Museo",
    park: "Parque",
    tourist_spot: "Lugar turístico",
    beach: "Playa",
    stadium: "Estadio",
    subway_train: "Metro / Tren",
    other: "Otro",
    gym: "Gimnasio",
    auditorium: "Auditorio",
    bars: "Bares",
    library: "Biblioteca",
    boutique: "Boutiques y tiendas de moda",
    atm: "Cajeros automáticos y casas de cambio",
    cafe: "Café",
    show_house: "Salas de espectáculos y presentaciones",
    cultural_center: "Centros culturales",
    convention_center: "Centros de convenciones",
    clinic: "Clínicas y hospitales",
    coworking: "Espacios de coworking",
    sweet_shop: "Dulcerías",
    event_space: "Espacios para eventos",
    handicraft_fair: "Ferias de artesanía",
    food_truck: "Food trucks",
    art_gallery: "Galerías de arte",
    laundry: "Lavanderías",
    car_rental: "Alquiler de coches y bicicletas",
    convenience_store: "Tiendas de conveniencia",
    souvenir_store: "Tiendas de souvenirs",
    open_market: "Mercados y ferias al aire libre",
    flea_market: "Mercados de pulgas",
    viewpoint: "Miradores y lugares turísticos",
    gas_station: "Estaciones de servicio",
    boat_tour: "Tours en barco y deportes acuáticos",
    salon: "Salones de belleza y barberías",
    transport_services: "Servicios de transporte (taxis, Uber, etc.)",
    ice_cream_shop: "Heladerías",
    spa: "Spas y centros de masajes",
    trails: "Senderos para caminatas",
    winery: "Bodegas y cervecerías artesanales",
    yoga: "Yoga y meditación",
    university: "Universidad",
    airport: "Aeropuerto",
    parking: "Estacionamiento",
  },
  nameLabel: "Nombre del lugar",
  cepLabel: "Código postal",
  streetLabel: "Calle",
  numberLabel: "Número",
  typeLabel: "Tipo",
  complementLabel: "Complemento (Opcional)",
  neighborhoodLabel: "Barrio",
  cityLabel: "Ciudad",
  stateLabel: "Estado",
  addPlace: "Agregar ubicación",
  nearbyPlacesI: "Lugares cercanos",
  cuisine: "Cocina",
  establishment: "Establecimiento",
  details: "Mostrar detalles",
  zipError: "Error al obtener el código postal",
  lang: "es_ES",
  failedFetchLivenessSession:
    "Error al iniciar la sesión de verificación de vida",
  failedCheckLivenessSession:
    "Resultado de verificación inconsistente. Inténtalo de nuevo.",
  cutImage: "Recortar imagen",
  rotateImage: "Girar",
  saveCut: "Guardar",
  saveAdditionalGuest: "Guardar",
  maxGuestsReached: "¡Número máximo de huéspedes alcanzado!",
  cancelCut: "Cancelar",
  infoForGuests:
    "Puedes completar los datos del otro huésped o enviarle el enlace para que lo complete él mismo",
  guestAlreadyRegisteredWarning:
    "El huésped ya registrado anteriormente no debe añadirse como huésped adicional.",
  noAdditionalGuests: "No hay huéspedes adicionales registrados",
  wasRefused:
    "Tu solicitud de reserva requiere ajustes. Por favor revisa el/los siguiente(s) punto(s).",
  property: "Propiedad",
  back: "Atrás",
  reservationCode: "Código de reserva",
  errorLoad: "Error al cargar datos. Inténtalo de nuevo",
  hi: "Hola",
  close: "Cerrar",
  chooseOptionBelow: "Elige la opción a continuación",
  fillData: "Completa los datos personales",
  seeDetails: "Ver detalles de la reserva",
  reservationInApproval: "Reserva pendiente de aprobación",
  waitingApproval:
    "<strong>Tu reserva está en proceso de aprobación.</strong> Una vez completada, todos los detalles de acceso e información sobre el alojamiento estarán disponibles aquí.",
  reservationDetails:
    "Dirección completa, detalles de acceso, contraseñas, reglas y consejos.",
  advertiseNavigateThroughNextAndBackButtons:
    "Para navegar entre las pestañas, usa los botones siguiente y atrás abajo",
  inAnalysis: "En análisis, por favor espera.",
  accessToPlace: "Acceso al lugar",
  filled: "¡YA EN ANÁLISIS O FINALIZADO!",
  CodeCopy: "¡Código copiado con éxito!",
  AddressCopy: "¡Dirección copiada con éxito!",
  loading_indicator: "Cargando datos, por favor espera.",
  step1: "Estancia",
  step2: "Datos del Huésped<br/> Titular de la Reserva",
  step3: "Huéspedes adicionales",
  step4: "Pago del depósito",
  step4AdditionalMode: "Tus datos",
  step5: "Documento del Huésped<br/> Titular de la Reserva",
  name: "Nombre completo del huésped",
  cpf: "CPF",
  foreignDocument: "Documento (Pasaporte, RNE)",
  isInternational: "¿internacional?",
  changeCheckinAndCheckoutTime:
    "Para cambiar las fechas y horarios de su estancia, póngase en contacto con soporte a través de WhatsApp, haga clic aquí.",
  isForeign: "¿extranjero?",
  email: "Correo electrónico del huésped",
  phone: "Teléfono del huésped",
  phone_whats: "Número de teléfono del huésped",
  birthDate: "Fecha de nacimiento",
  address: "Dirección del huésped",
  cep: "Código postal",
  postalCode: "Código postal",
  city: "Ciudad",
  state: "Estado",
  country: "País",
  number: "Número",
  addressLine1: "Dirección línea 1",
  addressLine2: "Dirección línea 2",
  street: "Calle",
  obs: "Complemento",
  residenceShortAddress: "Lugar",
  checkInDate: "Fecha de entrada",
  checkOutDate: "Fecha de salida",
  checkInTime: "Hora de entrada",
  checkInTimeSelector: "Seleccionar hora de entrada",
  checkOutTime: "Hora de salida",
  checkOutTimeSelector: "Seleccionar hora de salida",
  checkinCheckoutTimeSelectorClose: "Cerrar",
  visitPurpose: "Propósito de la visita",
  havePets: "¿Tienes mascotas?",
  bringPets: "Traer mascotas",
  bringPets_hint: "Este campo es solo para propiedades que permiten mascotas.",
  adults: "Número de adultos",
  adults_info:
    "Este número corresponde al total de adultos que están llenando el formulario o haciendo la reserva.",
  children: "Número de niños",
  submit: "ENVIAR DATOS",
  prev: "Atrás",
  next: "Siguiente",
  cancel: "Cancelar",
  yes: "Sí",
  no: "No",
  noData: "No hay datos para mostrar",
  noAirbnb: "Sin depósito, reserva a través de Airbnb",
  chooseCaptureMethod: "Elige una opción",
  captureOrUpload: "Tomar foto",
  sendFile: "Enviar archivo",
  attachFile: "Adjuntar archivo",
  changeFile: "Cambiar archivo",
  submitSuccess: "Datos enviados con éxito. Nos pondremos en contacto pronto.",
  submitSuccessAdditional: "Datos enviados con éxito.",
  failedLoadReservation: "Error al cargar datos de la reserva",
  submitError: "Error al guardar datos. Inténtalo de nuevo.",
  errors: {
    STAYS_DUPLICATED_EMAIL:
      "Error: 453534 - Email Duplicated - Contatar soporte.",
  },
  errorLoadingForm: "Error al cargar datos. Inténtalo de nuevo.",
  description: "Descripción",
  allAlright: "Todo bien, espera la liberación del acceso",
  justMainGuestCanFill:
    "Atención: solo el huésped principal de la reserva debe llenar este formulario.",

  // ----------validationSchema----------
  visitPurposes: {
    leisure: "Ocio - Vacaciones",
    work: "Negocios",
    shopping: "Compras",
    familyFriends: "Familia - Amigos",
    congressFair: "Congreso - Feria",
    course: "Estudios - Cursos",
    healthTreatment: "Salud",
    religion: "Religión",
    other: "Otro",
    notInformed: "No informado",
  },
  dontInformPurpose: "Prefiero no informar el propósito de la visita",
  termsConfirmation:
    "Al continuar, declaras que has leído y aceptas nuestros términos de privacidad y seguridad de datos",
  termsAcceptanceTitle: "Aceptar Términos de Uso y Políticas de Privacidad",
  termsAcceptanceMessage:
    "Para proceder con el formulario, debes aceptar nuestros términos de uso y políticas de privacidad.",
  termsCheckboxLabel: "He leído y acepto los {link}",
  imageTermsCheckboxLabel: "Acepto los {link}",
  imageTermsOfUse: "términos de uso de imagen",
  imageTermsTitle: "Términos de uso de imagen",
  userTermsCheckboxLabel: "He leído y acepto los {link}",
  userTermsOfUse: "Términos de uso {companyName}",
  userTermsTitle: "Términos de uso {companyName}",
  doNotAccept: "No aceptar",
  continueButton: "Continuar",
  mustAcceptTerms: "Debes aceptar los términos para continuar",
  readDocumentsMessage: "Para continuar, lee nuestros documentos:",
  termsOfUse: "Términos de Uso",
  privacyPolicyLink: "Política de Privacidad",
  areYouSureYouWantToExclude: "¿Estás seguro de que quieres eliminar {ref}?",
  withVehicle: "¿Piensas venir con vehículo?",
  addVehicle: "Agregar vehículo",
  removeVehicle: "Eliminar vehículo",
  vehicleType: "Tipo de vehículo",
  vehicleIndex: "Vehículo no.",
  vehicleTypeCar: "Auto",
  vehicleTypeMotorcycle: "Motocicleta",
  vehicleLicensePlate: "Modelo, color y patente del vehículo",
  residenceWithNoGarages: "Este lugar no incluye estacionamiento",
  residenceWithLimitedGarages:
    "Esta propiedad incluye estacionamiento para hasta {count} vehículo{suffix}",
  at: "en",
  fillCheckinTime: "Por favor, completa la hora de entrada",
  fillCheckoutTime: "Por favor, completa la hora de salida",
  guestRegister: "Registro del huésped",
  sections: {
    guestData: "Datos del huésped titular de la reserva",
    termsAndConditions: "Términos y condiciones",
    documents: "Documentos del huésped titular",
    documentsSubtitle:
      "Agrega foto del documento de identidad, licencia de conducir o pasaporte",
    additionalGuests: "Datos de los acompañantes",
    additionalGuestSpecific: "Datos del huésped adicional {nameOrIndex}",
    stayDetails: "Datos de la estancia",
    stayDetailsSubtitle: "Completa con los datos de la estancia",
  },

  residenceInfo: "Información importante",

  formSteps: {
    stayData: "Datos de la estancia",
    fillStayData: "Completa con los datos de la estancia",
    checkinTime: "Hora de entrada",
    checkoutTime: "Hora de salida",
    arrivalLabel: "Hora prevista de llegada (entrada)",
    arrivalNotice:
      "Indique la hora exacta prevista de su llegada y de su salida. Ayuda al anfitrión a preparar su recepción.",
    arrivalHint: "Hora exacta prevista de llegada",
    departureLabel: "Hora prevista de salida (salida)",
    departureHint: "Hora exacta prevista de salida",
    confirm: "Confirmar",
    visitPurpose: "Propósito de la visita",
    cars: "Autos",
    vehicle: "Vehículo",
    vehicleType: "Tipo de vehículo",
    vehiclePlate: "Modelo/Matrícula/Color del vehículo",
    noGarageWarning: "Este alojamiento no acepta autos",
    pets: "Mascotas",
    pet: "Mascota",
    petType: "Tipo de animal (ej: Perro, Gato)",
    noPetsWarning: "Este alojamiento no acepta mascotas",
    addAnimal: "Agregar animal",
    addAnimalInfo: "Ingresa el tipo de animal",
    addVehicle: "Agregar vehículo",
    addVehicleInfo: "Ingresa los datos del vehículo",
    cancel: "Cancelar",
    add: "Agregar",
    maxGuestsAllowed: "Esta reserva permite hasta",
    companion: "acompañante",
    companions: "acompañantes",
    addCompanion: "Agregar acompañante",
    removeCompanion: "Eliminar acompañante",
    thisReservationAllows: "Esta reserva permite",
    guestIndex: "Acompañante {index}",
    documentFront: "Foto del frente del documento",
    documentBack: "Foto del reverso del documento",
    faceSelfie: "Selfie del rostro",
    photoGuidelines: "Orientaciones para la foto",
    followForBestResults: "Sigue para mejores resultados",
    photoInWellLitPlace:
      "Fotografía en un lugar bien iluminado, evitando sombras o reflejos sobre el documento.",
    centerDocument:
      "Centra el documento en la pantalla, manteniendo todos los bordes visibles sin cortes.",
    holdPhoneSteady:
      "Sostén el teléfono firme o apóyalo en una superficie para evitar fotos borrosas y garantizar nitidez.",
    takePhoto: "Tomar foto",
    attachPhoto: "Adjuntar foto",
    selfieGuidelines: "Orientaciones para selfie del rostro",
    faceWellLit:
      "Ponte de frente a una fuente de luz natural o ambiente bien iluminado para evitar sombras.",
    faceFramed:
      "Mantén tu rostro completo dentro del encuadre, mirando directamente a la cámara.",
    removeAccessories:
      "Retira gafas de sol, gorras o cualquier elemento que pueda cubrir el rostro.",
    takeFaceSelfie: "Tomar selfie del rostro",
    selfiePreviewTitle: "¿Cómo quedó tu selfie?",
    selfiePreviewSubtitle: "Verifica la calidad antes de continuar.",
    selfiePreviewQualityWarning:
      "Asegúrate de que tu rostro esté completamente visible, bien iluminado y sin accesorios que lo cubran.",
    selfiePreviewAccept: "Continuar con esta selfie",
    selfiePreviewRetake: "Volver a tomar selfie",
  },

  navigation: {
    back: "Volver",
    next: "Siguiente",
  },

  validation: {
    required_birthDate: "La fecha de nacimiento es obligatoria",
    invalidDate: "Fecha inválida",
    minimumAge: "El huésped principal debe tener al menos 18 años",
    requiredCheckOutTime: "La hora de salida es obligatoria",
    requiredCheckInTime: "La hora de entrada es obligatoria",
    TimeOutOfRange: "Hora no disponible",
    checkInOutOfRange: "Hora de entrada no disponible",
    checkOutOutOfRange: "Hora de salida no disponible",
    required: "Este campo es obligatorio",
    email: "Correo inválido",
    name: "Nombre inválido",
    phone: "Número de teléfono inválido",
    min_adults: "Debe haber al menos un adulto",
    children: "Se requiere número de niños",
    validate_cpf: "Documento inválido",
    validate_phone: "Teléfono inválido",
    required_cpf: "Documento es obligatorio",
    required_document: "Documento es obligatorio",
    alert: "Completa todos los campos obligatorios",
    checkout_greater_than_checkin:
      "La fecha y hora de salida debe ser posterior a la de entrada.",
    required_address: {
      cep: "Código postal es obligatorio",
      postalCode: "Código postal es obligatorio",
      country: "País es obligatorio",
      city: "Ciudad es obligatoria",
      state: "Estado es obligatorio",
      number: "Número es obligatorio",
      street: "Calle es obligatoria",
    },
    vehicle: {
      missingVehicles: "Indícanos qué vehículos planeas traer.",
      missingWithVehicle: "Indícanos si planeas venir con vehículo o no.",
      missingVehicleType: "¡Tipo de vehículo es obligatorio!",
      missingVehicleLicensePlate:
        "¡Modelo, color y patente del vehículo son obligatorios!",
    },
    additionalGuestNameMissing:
      "El nombre del huésped adicional {nameOrIndex} es obligatorio",
    additionalInvalidCPF:
      "El CPF del huésped adicional {nameOrIndex} no es válido",
    additionalInvalidPhone:
      "El teléfono del huésped adicional {nameOrIndex} no es válido",
    missingAdditionalGuestBirthDate:
      "La fecha de nacimiento del huésped adicional {nameOrIndex} es obligatoria",
    additionalInvalidDocument:
      "El documento del huésped adicional {nameOrIndex} no es válido",
    additionalMissingDocumentFront:
      "Falta el anverso del documento del huésped adicional {nameOrIndex}",
    additionalMissingDocumentBack:
      "Falta el reverso del documento del huésped adicional {nameOrIndex}",
    additionalMissingDocumentSelfie:
      "Falta la selfie del huésped adicional {nameOrIndex}",
    missingDocumentFront: "Falta el anverso del documento",
    missingDocumentBack: "Falta el reverso del documento",
    missingDocumentDigital: "Falta el documento digital",
    missingDocumentSelfie: "Falta la autenticación facial",
    missingVisitPurpose:
      "El propósito de la visita o la opción 'Prefiero no informar el propósito de la visita' es obligatorio",
    addTheAdditionalGuests: "Agrega a los huéspedes adicionales",
    mustAcceptAllTerms: "Debes aceptar todos los términos para continuar",
    mustAcceptUserTerms: "Debes aceptar los términos de uso para continuar",
  },
  reservationRefused: "Su formulario necesita revisión",

  importantInfoBeforeContinue: "Información importante antes de continuar",

  readAndAccept: "He leído y acepto",

  dontAccept: "No acepto",

  importPreviousReservationData: {
    importReservationData: "Importar datos de la reserva",
    sixDigitsCode: "Código de 6 dígitos",
    confirm: "Confirmar",
    resendCode: "Reenviar Código",
    await: "Espera",
    continueWithoutImport: "Continuar sin Importar",
    invalidDate: "Fecha inválida",
    close: "Cerrar",
    errorSendingEmail: "Error al enviar correo electrónico.",
    errorSendingWhatsApp: "Error al enviar WhatsApp.",
    errorSendingCode: "Error al enviar código.",
    dataImportedSuccessfully: "¡Datos importados con éxito!",
    informSixDigitsCode: "Por favor, ingresa el código de 6 dígitos.",
    youAlreadyIsOurClient:
      "Nos hemos dado cuenta de que ya te has alojado en una agencia asociada a Selfie Checkin. ¿Te gustaría importar los datos de alguna de tus reservas anteriores?",
    noInformedCompany: "Empresa no informada.",
    import: "Importar",
    previousReservations: "Reservas anteriores",
  },
  goToPreviousReservation: "Ya tienes una reserva en curso. ¿Te gustaría ir?",
  reservationInProgress: "Reserva en curso",

  //-------------Doc---------
  doc: {
    tab1: "Documento<br>físico (Foto)",
    tab2: "Documento digital<br>(Foto o PDF)",
    front: "Anverso del documento del huésped responsable",
    back: "Reverso del documento del huésped responsable",
    pdf: "Adjuntar documento digital (PDF)",
    title1: "1. Envía una foto del anverso de tu documento",
    title2: "2. Envía una foto del reverso de tu documento",
    title3: "3. Ahora, comencemos el proceso de autenticación facial",
    title4: "1. Envía tu documento digital",
    title5: "2. Ahora, comencemos el proceso de autenticación facial",
    text1:
      "Se aceptan documentos con foto como DNI, licencia de conducir o pasaporte.",
    text1_1:
      "Recuerda que si es DNI o licencia, el documento suele estar <b>doblado</b> dentro de una funda, por lo que debes sacarlo y desplegarlo para tomar la foto. Como en la imagen abajo:",
    text2:
      "Envía una foto del reverso del documento que enviaste en el campo 1.",
    text3:
      "El proceso es bastante simple. Al hacer clic en 'Iniciar autenticación', activa la cámara de tu teléfono y posiciona tu rostro dentro de las áreas designadas.",
    text3_1:
      "Necesitaremos acceso a tu cámara. Si usas una computadora sin webcam, puedes completar este paso en tu teléfono móvil.",
    text4: "Adjunta tu documento digital, un archivo que contenga el código QR",
    missingDocs: "¡Adjunta todos los documentos requeridos!",
    missingSelfie: "¡Por favor, completa la autenticación facial!",
    startAuthentication: "Iniciar autenticación",
    authenticationAdditionalGuest: "Selfie del huésped adicional {nameOrIndex}",
    startAgainAuthentication: "Guardado. ¿Repetir?",
  },

  // --------Additional Guest-----
  additionalGuest: {
    notAllowedAdditionalGuests:
      "No se permiten huéspedes adicionales para esta reserva.",
    add: "Agregar nuevo",
    askReload:
      "Esta opción se utiliza para recuperar los datos ingresados por los huéspedes adicionales a través del enlace que les enviaste. ¿Estás seguro?",
    reload: "Recuperar datos ya completados",
    fill: "Completar datos",
    view: "Ver datos",
    del: "Eliminar huésped",
    copy: "Enviar enlace para completar datos",
    copied: "Enlace copiado con éxito. Puedes enviarlo al huésped adicional",
    heading: "Información de huéspedes adicionales",
    name: "Nombre completo del huésped",
    cpf: "CPF del huésped",
    passport: "Pasaporte/RNE del huésped",
    isChild: "¿Es usted un niño o menor de edad?",
    foreignCheckbox: "¿Extranjero?",
    document: "Documento del huésped (anverso) o documento completo",
    documentBack: "Documento del huésped (reverso)",
    downloadDocument: "Ver documento anverso",
    downloadDocumentBack: "Ver documento reverso",
    hasAdditional: "¿Tienes huéspedes adicionales?",
    howManyAdditional: "¿Cuántos huéspedes adicionales tienes?",
    facialRecognitionInfo:
      "Se requiere autenticación facial para todos los huéspedes adicionales.",
    isntPossibleToAddAdditionalGuests:
      "No es posible agregar huéspedes adicionales a esta reserva.",
    giveTheDipositiveToTheGuestMakeSelfie:
      "Por favor, pásale el dispositivo al huésped adicional para que se tome la selfie.",
    reloadedSuccess: "Datos recuperados con éxito.",
  },

  wait: {
    thankYou: "¡Gracias!",
    waitTitle: "Por favor espera",
    waitMessage:
      "Estamos procesando tu información. Alguien de nuestro equipo se pondrá en contacto contigo pronto para continuar con tu registro.",
    callToAction: "Volver al inicio",
  },

  cautionPayment: {
    question: "¿Tu reserva tiene un depósito?",
    cautionCoveredByAirCover:
      "¡Tu reserva está cubierta por el seguro AirCover de Airbnb! Haz clic abajo para avanzar.",
    noCautionMessage: "Tu reserva no tiene depósito.",
    heading: "Depósito de Seguridad",
    howItWorks: "¿Cómo funciona?",
    subheading: "Completa con los datos de la estancia",
    cautionValue:
      "El monto del depósito de seguridad para esta reserva es: R$ {value}",
    cautionValueMessage:
      "El valor de este depósito es <strong>{value}</strong>.",
    pixKeyLabel: "Clave pix",
    attachProof: "Adjuntar comprobante de pago",
    copied: "¡Clave Pix copiada con éxito!",
    missingCautionPayment:
      "Es necesario adjuntar el comprobante de pago del depósito",
    downloadProof: "Descargar comprobante de pago",
    replaceProof: "Reemplazar comprobante de pago",
    selectMethod: "Seleccione el método de pago",
    creditCard: "Tarjeta de Crédito (Pre-autorización)",
    pix: "Pix",
    insurance: "Seguro Check-in",
    bestOption: "MEJOR OPCIÓN",
    whatIsCaution: "¿Qué es un depósito de seguridad?",
    processedBy: "Procesado por",
    paymentWindowError:
      "El pago del depósito deberá realizarse entre {startDate} y {endDate}.",
    preAuthLabel: "PREAUTORIZACIÓN",
    cardData: "Datos de la tarjeta",
    cardNumber: "Número de tarjeta",
    cardHolder: "Nombre en la tarjeta",
    expirationMonth: "Mes",
    expirationYear: "Año",
    cvv: "Código de seguridad (CVV)",
    installments: "Cuotas",
    preAuthWarning:
      "La preautorización ocurre hasta 3 días antes del check-in. Verifique si hay límite disponible en la tarjeta durante este período.",
    billingAddress: "Dirección de facturación",
    useReservationAddress: "¿Usar dirección de la Reserva?",
    complement: "Complemento",
    zipCode: "Código postal",
    city: "Ciudad",
    state: "Estado",
    number: "Número",
    street: "Calle",
    missingPaymentMethod: "Seleccione un método de pago para el depósito",
    paymentRequired: "El pago del depósito de seguridad es obligatorio",
    missingCardNumber: "El número de tarjeta es obligatorio",
    missingCardHolder: "El nombre en la tarjeta es obligatorio",
    missingExpirationMonth: "El mes de expiración es obligatorio",
    missingExpirationYear: "El año de expiración es obligatorio",
    missingCvv: "CVV es obligatorio",
    missingZipCode: "El código postal es obligatorio",
    missingCity: "La ciudad es obligatoria",
    missingState: "El estado es obligatorio",
    missingStreet: "La calle es obligatoria",
    missingAddressNumber: "El número es obligatorio",
    missingNeighborhood: "El barrio es obligatorio",
    pixGeneratedNextStep:
      "Tu PIX será generado en el siguiente paso para pago inmediato.",
    pixTimerMessage: "Tienes {minutes} minutos para completar el pago.",
    pixExpired: "Pago no realizado",
    pixTryAgain: "Inténtelo de nuevo",
    pollingTimeout:
      "Se agotó el tiempo de confirmación del pago. Por favor, inténtelo de nuevo.",
    comingSoon: "Próximamente",
    apiErrors: {
      GUEST_NOT_FOUND: "Huésped no encontrado.",
      NO_CAUTION_VALUE:
        "No hay monto de depósito de seguridad configurado para esta reserva.",
      INCOMPLETE_GUEST_DATA:
        "Datos incompletos. Complete nombre, correo, CPF y teléfono antes de pagar.",
      INVALID_PHONE:
        "Número de teléfono inválido. Verifique el número ingresado.",
      CAUTION_PERIOD_EXPIRED:
        "El período de pago del depósito de seguridad ha finalizado.",
      LONG_STAY_NO_CREDIT_CARD:
        "El pago con Tarjeta de Crédito no está disponible para reservas de más de 30 días.",
      CREDIT_CARD_TOO_EARLY:
        "El pago con Tarjeta de Crédito solo está disponible 30 días antes del checkout.",
      CAUTION_PAYMENT_PENDING:
        "El pago del depósito de seguridad con tarjeta aún no fue confirmado. Complete el pago antes de finalizar.",
    },
    loadingPayment: "Cargando entorno de pago seguro...",
    secureEnvironment: "Pago procesado en entorno seguro de Pagar.me",
    paymentConfirmed: "¡Depósito de seguridad confirmado con éxito!",
    alreadyPaidTitle: "Caución ya pagada",
    alreadyPaidSubtitle: "El pago de la caución ya fue realizado anteriormente. Puede continuar sin pagar de nuevo.",
    pixModalTitle: "Pago del Depósito de Seguridad",
    pixPaymentRealized: "¡Pago Realizado!",
    pixPaymentIdentifiedWait:
      "El pago fue identificado con éxito. Por favor, espere un momento...",
    pixPaymentIdentified: "El pago fue identificado con éxito.",
    pixModalDescription:
      "Escanee el código QR a continuación para realizar el pago vía PIX. La confirmación es instantánea.",
    pixCopyPasteLabel: "Código PIX Copia y Pega",
    pixModalWarning:
      "No cierre esta página. El sistema avanzará automáticamente después de la confirmación del pago.",
    pixModalWaiting: "Esperando confirmación del banco...",
    iframeError: "Error al cargar el pago. Por favor, inténtelo de nuevo.",
    retryPayment: "Intentar de nuevo",
    confirmPreAuth: "Confirmar preautorización",
    cautionBlocked:
      "El período de pago del depósito de seguridad ha finalizado porque la reserva ya pasó la fecha de checkout.",
    longStayNoCreditCard:
      "Para reservas de más de 30 días, el pago del depósito de seguridad con Tarjeta de Crédito no está disponible. Por favor, utilice la opción PIX.",
    creditCardReleaseDateMessage:
      "El pago con Tarjeta de Crédito para el depósito de seguridad estará disponible 30 días antes de la fecha de checkout - {date}",
  },
  talkOnWhatsApp: "Ir a WhatsApp",
  contactUs: "¿Preguntas? Hable con nosotros",

  imageTermsContent: {
    title: "TÉRMINOS DE USO / TÉRMINOS DE USO DE LA IMAGEN",
    content: `En "Selfie Check-in" nos tomamos en serio tu privacidad y la protección de tus datos. Por eso, hemos creado nuestra Política de Privacidad ("Política") para que tú, nuestro usuario ("Usuarios"), puedas verificar i) qué información personal se recopila; ii) cómo se utiliza y comparte dicha información personal; y iii) qué derechos de privacidad tienen nuestros usuarios.

Nuestra política se aplica cuando utilizas nuestros sitios web, completas nuestros formularios o contratas nuestros servicios.

Las cookies son pequeños archivos de texto (generalmente cifrados) que quedan almacenados en los navegadores después de que el usuario accede a un sitio web. A través de ellas es posible identificar el dispositivo de acceso utilizado.

Al acceder al sitio web, el usuario reconoce ser el único responsable de la veracidad, exactitud y autenticidad de los datos proporcionados, comprometiéndose, además, a la custodia, confidencialidad y buen uso de cualquier usuario y contraseña registrados.

EN POCAS PALABRAS: TÉRMINOS Y CONCEPTOS QUE NECESITAS CONOCER

Cifrado
El cifrado es un mecanismo de seguridad y privacidad utilizado para codificar y decodificar datos. Su objetivo es proteger la información confidencial frente a amenazas y accesos no autorizados.

Cookies

CRM
Sigla del término en inglés Customer Relationship Management, que puede traducirse al español como Gestión de la Relación con el Cliente.

Dato Personal
Es una información relacionada con una persona física que es capaz de identificar a la persona o de hacer posible su identificación.

IP (Internet Protocol)
Es el Protocolo de Internet, cuyo objetivo es identificar cada dispositivo conectado a la red mediante una numeración única.

Tratamiento
Es toda forma de uso que podemos hacer de tus Datos Personales, incluidas, entre otras, las siguientes actividades: recopilación, almacenamiento, consulta, uso, intercambio, transmisión, clasificación, reproducción, eliminación y evaluación.

Titular
Eres tú, la persona física a la que se refieren los Datos Personales.

CUÁNDO Y QUÉ DATOS SE RECOPILAN

Selfie Check-in podrá recopilar los datos siempre que haya una interacción activa y voluntaria del usuario al registrarse en el sitio web y también a través del uso de nuestros canales de comunicación, que incluyen: (a) WhatsApp corporativos (central de Selfie Check-in y atención de emergencias), (b) comunicación a través de los chats de las plataformas (Airbnb, Booking, Expedia y otras), (c) contacto por correo electrónico, (d) registro en el sitio web, (e) contacto telefónico por línea fija.

Datos de navegación de los visitantes del sitio web
• Direcciones IP utilizadas;
• Clics; y
• Tiempos de visita.

Estos datos se recopilan a través de "cookies", lo que hace que tu experiencia en línea sea más fácil, rápida y accesible, ahorrando información de navegación.

Datos de registro
• Nombre Completo
• Correo electrónico
• CNH (licencia de conducir brasileña)
• RNE (registro de extranjeros en Brasil) para usuarios extranjeros
• Pasaporte para usuarios extranjeros
• Sexo
• Fecha de nacimiento
• CPF (número de contribuyente brasileño)
• Nacionalidad
• Idioma
• RG (documento de identidad brasileño)
• Celular
• CEP (código postal)
• Dirección
• Ciudad/Estado
• Contraseña
• Partida de nacimiento para menores

Datos de pago
• Datos Bancarios
• Forma de pago: tarjeta de crédito, Pix, PayPal o transferencia bancaria)

Además de los instrumentos de pago utilizados, también podrán recopilarse la fecha y hora, el importe del pago, la fecha de vencimiento del instrumento de pago y el código postal de facturación, la dirección de correo electrónico de PayPal, la dirección del usuario y otra información relacionada con la transacción, como medio de protección y prevención contra el fraude.

Documentos recopilados
Para la realización y finalización de las reservas, es necesario el envío de los siguientes documentos:
• Foto del documento de identidad por ambas caras: RG, CNH, RNE y pasaporte para usuarios extranjeros;
• Partida de nacimiento, u otro documento oficial que demuestre el vínculo, en el caso de menores (Conforme a lo dispuesto en la Ley n.º 8.069/1990, para realizar la reserva es necesaria la presentación del documento de identidad del menor.)
• Foto del titular de la reserva con el documento en la mano.

FINALIDAD DE LA RECOPILACIÓN DE LOS DATOS

Los datos personales recopilados podrán utilizarse de las siguientes formas:
✔ Para hacer posible el uso y la experiencia de los servicios contratados;
✔ Para elaborar estadísticas, estudios, investigaciones y análisis pertinentes a las actividades y al comportamiento en el uso de los Servicios, realizando dichas operaciones de forma anonimizada;
✔ Para permitir tu participación en promociones y la difusión de materiales de marketing;
✔ Para procesar pagos y hacer posible la prestación del servicio ofrecido por el sitio web;
✔ Para Comunicación, pudiendo enviarse avisos y notificaciones importantes relacionados con el usuario, como cambios en esta Política, nuevos productos/servicios y encuestas de satisfacción;
✔ Cumplimiento de obligaciones legales y defensa de derechos, pudiendo utilizarse para el cumplimiento de obligaciones legales o regulatorias, así como para la defensa de derechos en conflictos judiciales o extrajudiciales;
✔ Para efectuar el pago de los productos que el usuario ha seleccionado; Para responder a las solicitudes del usuario;
✔ Para implementar y aportar mejoras/perfeccionamientos en la propia prestación de los servicios.

INTERCAMBIO DE DATOS

El intercambio de los datos personales de los usuarios se realizará siempre dentro de los límites legales, observando especialmente lo que determina la Ley n.º 13.709/2018 ("LGPD", Ley General de Protección de Datos de Brasil), teniendo siempre en cuenta los propósitos de la relación entre el sitio web y el usuario y el negocio desarrollado por "Selfie Check-in".

Los datos personales de los usuarios pueden compartirse con empresas del mismo grupo, empresas subsidiarias, afiliadas, socios, proveedores y prestadores de servicios, para finalidades legítimas, de la siguiente manera:
✔ Para la realización de las actividades de tratamiento de datos personales descritas anteriormente, incluido el almacenamiento de los datos personales recopilados;
✔ Para cumplir obligaciones legales, regulatorias o contractuales;
✔ Para el ejercicio del interés legítimo;
✔ Como medio para evitar fraudes y proteger los datos de los usuarios

Los socios solo están autorizados a utilizar los datos personales para los fines para los que fueron contratados, quedando prohibida la utilización de los datos personales de los usuarios para finalidades distintas de la prestación de servicios prevista contractualmente.

ALMACENAMIENTO DE LOS DATOS

Los datos personales de los usuarios se almacenarán solo durante el tiempo necesario para alcanzar las finalidades aquí presentadas.

A efectos de auditoría y preservación de los derechos de los usuarios, los datos podrán almacenarse durante un período máximo de 5 (cinco) años contados a partir de la cancelación de cualquier cuenta de acceso, pudiendo extenderse por un plazo mayor en los casos en que la ley o una norma regulatoria así lo establezca o para la preservación de derechos.

TRATAMIENTO DE DATOS SENSIBLES – RECONOCIMIENTO FACIAL

En el marco de la prestación de los servicios, Selfie Check-in podrá realizar el tratamiento de datos biométricos (imágenes faciales) con fines de verificación de identidad y prevención de fraudes en el proceso de check-in.

Estos datos se clasifican como datos personales sensibles, conforme a lo previsto en el art. 5, II, de la LGPD. El tratamiento se realizará en estricta observancia de las bases legales previstas en el art. 11 de la LGPD, en especial:

Para el cumplimiento de una obligación legal o regulatoria, cuando corresponda;

El reconocimiento facial se utilizará exclusivamente para verificar la identidad del huésped y garantizar la seguridad del alojamiento, sin emplearse para ninguna otra finalidad incompatible.

La información biométrica recopilada se almacenará en un entorno seguro, con uso de cifrado, control de acceso restringido y registros de auditoría, y será descartada o anonimizada tan pronto como se cumpla la finalidad para la que fue obtenida, respetando los plazos legales.

El titular podrá revocar en cualquier momento el consentimiento otorgado para este tratamiento, mediante solicitud al Encargado de Protección de Datos (DPO), siendo consciente de que la revocación podrá imposibilitar la realización del check-in automatizado.

DERECHOS DE LOS USUARIOS

En los términos de la LGPD, los usuarios tienen derechos y garantías en relación con sus datos. Ponemos a disposición mecanismos, detallados a continuación, para que nuestro usuario tenga claridad y transparencia en el ejercicio de sus derechos.

Los usuarios podrán:
✔ Solicitar detalles y/o copia de sus datos almacenados por Selfie Check-in;
✔ Modificar o corregir sus datos, mediante solicitud por correo electrónico o WhatsApp;
✔ Confirmar la existencia de tratamiento de los datos;
✔ Corregir los datos incompletos, inexactos o desactualizados;
✔ Obtener la anonimización, el bloqueo o la eliminación de datos innecesarios, excesivos o tratados en disconformidad con lo dispuesto en la LGPD;
✔ Solicitar la portabilidad de los datos a otro proveedor de servicios o productos, mediante solicitud expresa, de acuerdo con la reglamentación de la Autoridad Nacional, respetando los secretos comerciales e industriales;
✔ Eliminar los datos personales tratados con el consentimiento del titular, excepto en los casos previstos en el art. 16 de la Ley;
✔ Solicitar información sobre las entidades públicas y privadas con las que el Responsable haya compartido datos;
✔ Solicitar información sobre la posibilidad de no otorgar el consentimiento y sobre las consecuencias de la negativa;
✔ Solicitar la revocación del consentimiento, en los términos del § 5 del art. 8 de la Ley.

Para ejercer todos tus derechos o aclarar cualquier duda, ponte en contacto con contato{'@'}selfiecheckin.com.br

PROTECCIÓN DE LOS DATOS

Selfie Check-in almacena los datos en entornos operativos que utilizan medidas de seguridad técnicas y administrativas para prevenir cualquier tipo de acceso no autorizado y situaciones accidentales o ilícitas de destrucción, pérdida, alteración, comunicación o difusión, utilizando tecnologías y procedimientos de seguridad para ayudar a proteger los datos personales contra accesos indebidos, como, por ejemplo, el uso de la autenticación de dos factores para acceder al sistema, que el usuario debe configurar.

Todos los datos recopilados se almacenan en un entorno seguro y controlado, durante un plazo mínimo de 6 (seis) meses, en los términos del Marco Civil de Internet de Brasil.

Los datos pueden almacenarse en nuestros propios servidores o en los de un tercero contratado para ese fin, ubicados en Brasil o en el extranjero, de acuerdo con la LGPD.

Selfie Check-in podrá poner a disposición de los propietarios/anfitriones mecanismos para registrar valoraciones y comentarios sobre el alojamiento realizado por los usuarios. Estas valoraciones podrán contener información sobre el comportamiento, el cumplimiento de las normas del inmueble y el historial de la estancia, constituyendo datos personales vinculados al titular.

El tratamiento de estos datos tiene como finalidades:
garantizar una mayor transparencia y seguridad en la relación entre huéspedes y anfitriones;
permitir el mantenimiento de un entorno confiable en la plataforma;
respaldar eventuales medidas de prevención de fraudes o incumplimientos contractuales.

Las valoraciones permanecerán almacenadas durante el plazo necesario para el cumplimiento de estas finalidades, pudiendo ser consultadas por los respectivos propietarios y, cuando corresponda, utilizadas por Selfie Check-in para análisis estadísticos o mejora de los servicios.

PLATAFORMAS SUJETAS AL INTERCAMBIO DE LOS DATOS

1. Cloud, AWS
2. Stripe
3. D4S Serviços em Tecnologia
4. Airbnb
5. Booking
6. Expedia
7. TripAdvisor
8. Responsables de limpieza/mantenimiento/portería/conserjes/caseros (personas físicas)
9. Propietarios (personas físicas)
10. Equipo de Selfie Check-in
11. Paypal
12. Meta (Facebook, Instagram, Whatsapp)
13. Google (gmail, Google drive)
14. Microsoft (Outlook, Teams, One Drive)
15. Sistemas de Portería.

Promociones y Beneficios de Socios

Nuestra plataforma puede poner a disposición del cliente información sobre promociones, descuentos y beneficios ofrecidos por socios, tales como servicios de alquiler de automóviles, reservas de alojamiento, transporte u otras actividades relacionadas.

El acceso a estas promociones se produce exclusivamente por iniciativa del cliente, a través de enlaces o redireccionamientos a los sitios web o aplicaciones de los respectivos socios.

Cabe aclarar que:
• No se produce ningún intercambio de datos personales entre nuestra plataforma y los socios en el momento del acceso.
• La eventual recopilación y tratamiento de datos personales pasa a regirse exclusivamente por la política de privacidad del socio, que recomendamos consultar antes de continuar con la utilización del servicio.
• Nuestra plataforma se limita a poner a disposición la información sobre la promoción, sin ninguna intervención en el procesamiento de datos personales ni en la prestación del servicio contratado con el socio.

CAMBIOS EN ESTA POLÍTICA

Las disposiciones de esta Política pueden modificarse en cualquier momento. Siempre que la Política se modifique, los cambios se publicarán en el sitio web de la Plataforma y podrán enviarse por correo electrónico.

CONTACTO

Cualquier duda relacionada con la privacidad podrá enviarse al Encargado de Protección de Datos (DPO) de Selfie Check-in, a través del correo electrónico: dpo{'@'}selfiecheckin.com.br

Intercambio de datos: podrá producirse con procesadores de pago

Última Modificación: octubre 2026

Selfie Check-in realiza el tratamiento de (p. ej., PayPal, Stripe), proveedores de servicios de alojamiento en la nube, datos personales en estricta observancia de la Ley General de Protección de Datos (Ley n.º 13.709/2018 – LGPD) y de las directrices de la Autoridad Nacional de Protección de Datos (ANPD). El ciclo de vida de los datos comprende la recopilación, el almacenamiento, la utilización, el intercambio y la posterior eliminación o anonimización, respetando los plazos legales y las finalidades específicas.

Datos recopilados: nombre completo, documentos de identidad (RG/CPF, pasaporte), dirección, teléfono, correo electrónico, datos bancarios y de pago, fotografía/perfil, información sobre el historial de comportamiento y valoraciones, así como datos de geolocalización durante el check-in/check-out, cuando corresponda.

proveedores de correo electrónico, servicios de análisis de riesgo de fraude, autoridades públicas cuando sea necesario, y socios contratados para la ejecución de los servicios.

Seguridad: se adoptan medidas técnicas y administrativas adecuadas, incluyendo cifrado en reposo y en tránsito, autenticación multifactor, registros de acceso, firewalls, antivirus y rutinas periódicas de copia de seguridad, con control de acceso restringido a administradores, moderadores y soporte técnico.

Derechos de los titulares: los usuarios podrán ejercer los derechos previstos en el art. 18 de la LGPD (acceso, corrección, eliminación, anonimización, bloqueo, portabilidad, revocación del consentimiento, entre otros) mediante solicitud al Encargado de Protección de Datos (DPO) a través del canal indicado en esta Política`,
  },

  termsOfUseContent: {
    title: "TÉRMINOS Y CONDICIONES DE USO – SELFIE CHECK-IN",
    content: `1. Aceptación de los Términos

Al acceder y utilizar la plataforma Selfie Check-in, el usuario declara que ha leído, comprendido y acepta cumplir íntegramente los presentes Términos de Uso, así como la Política de Privacidad disponible en el sitio web.

2. Objeto

Selfie Check-in pone a disposición una plataforma digital destinada a facilitar procesos de check-in automatizado en inmuebles de alojamiento, permitiendo la recopilación y validación de datos de huéspedes, la comunicación con propietarios/anfitriones y la gestión de reservas.

3. Condiciones de Uso

- El usuario se compromete a proporcionar información verdadera, completa y actualizada.
- El uso de la plataforma está restringido a mayores de 18 años o a menores debidamente autorizados por sus representantes legales.
- Está prohibido cualquier uso ilícito, fraudulento o que pueda comprometer la seguridad de la plataforma o de terceros.

4. Registro y Cuenta de Usuario

- Para acceder a determinadas funcionalidades, el usuario podrá tener que crear una cuenta, eligiendo credenciales de acceso (usuario y contraseña).
- El usuario es responsable de la confidencialidad de sus credenciales y de todas las actividades realizadas en su cuenta.
- Selfie Check-in se reserva el derecho de suspender o cancelar las cuentas que infrinjan los presentes Términos.

5. Datos Personales y Privacidad

- El tratamiento de datos personales, incluidos los datos sensibles (p. ej., biometría facial), se rige por la Política de Privacidad de Selfie Check-in, elaborada de conformidad con la LGPD (Ley General de Protección de Datos de Brasil – Ley n.º 13.709/2018).
- El usuario declara ser consciente de que determinadas funcionalidades (p. ej., el reconocimiento facial para la prevención de fraudes) dependen de que otorgue su consentimiento expreso.

6. Responsabilidades de Selfie Check-in

Selfie Check-in se compromete a:

- Garantizar el funcionamiento regular de la plataforma, salvo en situaciones de mantenimiento, actualización o fuerza mayor;
- Proteger los datos personales de los usuarios, adoptando medidas técnicas y administrativas adecuadas;
- Cumplir con la legislación aplicable en materia de privacidad, protección de datos y defensa del consumidor.

7. Responsabilidades del Usuario

El usuario se compromete a:

- Utilizar la plataforma únicamente para los fines legalmente permitidos;
- No reproducir, copiar, distribuir ni modificar ninguna parte de la plataforma sin autorización previa;
- No acceder a áreas restringidas ni a sistemas de Selfie Check-in por medios no autorizados.

8. Propiedad Intelectual

Todos los contenidos de la plataforma (marcas, logotipos, software, textos, imágenes y diseño) son propiedad de Selfie Check-in o de terceros licenciantes, y queda prohibida su utilización sin autorización expresa.

9. Limitación de Responsabilidad

- Selfie Check-in no se responsabiliza por daños derivados de fallos en la conexión a internet, de sistemas de terceros o del uso indebido de la plataforma.
- La responsabilidad de Selfie Check-in se limita a los servicios que presta, dentro de los límites legalmente permitidos.

10. Modificaciones de los Términos de Uso

Selfie Check-in podrá modificar estos Términos de Uso en cualquier momento. Las modificaciones se publicarán en el sitio web y entrarán en vigor en la fecha de su divulgación. El uso continuado de la plataforma implica la aceptación de las nuevas condiciones.

11. Contacto

Para cualquier duda sobre los presentes Términos de Uso, el usuario podrá ponerse en contacto con Selfie Check-in a través del correo electrónico: contato{'@'}selfiecheckin.com.br

12. Ley Aplicable y Jurisdicción

Estos Términos de Uso se rigen por la legislación brasileña (LGPD y normas de defensa del consumidor), y se elige la jurisdicción de los tribunales de la sede de Selfie Check-in para la resolución de eventuales conflictos, salvo que la ley establezca una competencia distinta.`,
  },
  homeV2: {
    hero: {
      titleLine1: "Todo el recorrido del huésped.",
      titleLine2: "Una plataforma.",
      subtitle: "Automatización, seguridad e IA para conectar tu operación, desde la reserva hasta después de la estadía.",
      ctaPrimary: "Conoce más",
      ctaSecondary: "Habla con nuestro equipo",
      mockupAlt: "Panel de Selfie Check-in con reservas, check-ins pendientes y el estado de cada huésped",
    },
    logos: {
      label: "Plataformas integradas",
    },
    pillars: {
      titleLead: "La hospitalidad es tuya.",
      titleAccent: "La conexión queda con Selfie.",
      lead: "Documentos por revisar, mensajes por responder y accesos por coordinar. Reúne las etapas del alojamiento para seguir cada reserva con más organización.",
      automation: {
        title: "Automatización que acompaña la reserva.",
        text: "El check-in digital, las notificaciones y las integraciones conectan la información del huésped con el día a día de la operación.",
      },
      security: {
        title: "Seguridad para decidir con contexto.",
        text: "Documentos, selfie y validaciones reúnen información para apoyar el análisis de la llegada. La garantía y la firma electrónica completan el recorrido.",
      },
      ai: {
        title: "IA presente a lo largo de la estadía.",
        text: "Un agente apoya el check-in, responde dudas sobre el inmueble y deriva las situaciones que necesitan atención humana.",
      },
    },
    journey: {
      titleLine1: "Un recorrido completo.",
      titleAccent: "Etapas",
      titleAfter: " conectadas.",
      lead: "Desde el primer contacto hasta el historial de la estadía, cada etapa prepara la siguiente.",
      step1: {
        title: "Reserva",
        text: "El anfitrión registra el inmueble y los datos de la reserva para iniciar el recorrido del huésped en la plataforma.",
      },
      step2: {
        title: "Comunicación",
        text: "El huésped recibe las indicaciones del alojamiento y el enlace para hacer el check-in digital antes de llegar.",
      },
      step3: {
        title: "Check-in",
        text: "El huésped completa sus datos y envía los documentos y una selfie por el formulario digital.",
      },
      step4: {
        title: "Validación",
        text: "Los datos se verifican y se realiza una consulta de antecedentes penales vía SERPRO. Si hay registro, se avisa al anfitrión para que evalúe el alojamiento.",
      },
      step5: {
        title: "Garantía",
        text: "La garantía ofrece un respaldo financiero ante posibles daños y da más seguridad al anfitrión según las condiciones acordadas para el alojamiento.",
      },
      step6: {
        title: "Acceso",
        text: "Tras la aprobación, la recepción recibe la información para la entrada. El acceso por cerraduras inteligentes puede automatizarse según la integración disponible.",
      },
      step7: {
        title: "Estadía",
        text: "El huésped accede a la Guía del Huésped, con indicaciones sobre el inmueble y recomendaciones de la zona, y cuenta con atención durante la estadía.",
      },
      step8: {
        title: "Después del check-out",
        text: "Los datos de la reserva, del check-in y el historial de la estadía quedan registrados para futuras consultas. Se puede invitar al huésped a valorar su experiencia.",
      },
    },
    ai: {
      badge: "Inteligencia artificial",
      title: "Un agente de IA que te ayuda a gestionar las estadías",
      lead: "La tecnología te apoya mientras te enfocas en lo que de verdad importa.",
      phoneAlt: "Pantalla de mensajes de Selfie Check-in con el chatbot atendiendo huéspedes",
      before: {
        title: "Antes de la llegada",
        text: "Recoge información y sigue el avance del check-in.",
      },
      during: {
        title: "Durante el alojamiento",
        text: "Responde dudas usando la información del inmueble.",
      },
      after: {
        title: "Después del check-out",
        text: "Puede solicitar la valoración del huésped.",
      },
      human: {
        title: "Cuando hace falta una persona",
        text: "Deriva las situaciones a la atención humana.",
      },
    },
    checkin: {
      eyebrow: "Reserva y registro",
      title: "Check-in digital antes de la llegada y validación de identidad",
      photoAlt: "Huésped tomándose una selfie con el móvil en la puerta del inmueble",
      document: {
        title: "Documento",
        text: "Revisión de los datos enviados por el huésped.",
      },
      selfie: {
        title: "Selfie",
        text: "Comparación facial con el documento presentado.",
      },
      verification: {
        title: "Verificación de seguridad",
        text: "Consulta de datos oficiales vía SERPRO.",
      },
    },
    integrations: {
      eyebrow: "Una operación más alineada",
      title: "Conexión entre todos los puntos de contacto",
      lead: "Anfitrión, administradora, propietarios y recepción: información compartida para preparar la llegada y seguir la reserva.",
      hostPhotoAlt: "Anfitrión consultando la reserva desde el móvil",
      gatePhotoAlt: "Conserje revisando las cámaras y la ficha de la reserva en la recepción",
      pms: {
        title: "Reservas y PMS",
        text: "Conexión con gestores de reservas para apoyar el flujo del alojamiento.",
      },
      gate: {
        title: "Recepciones y edificios",
        text: "Confirmación y ficha de la reserva tras la aprobación, con integración al edificio cuando es compatible.",
      },
      locks: {
        title: "Cerraduras inteligentes",
        text: "Automatización del acceso según la integración disponible.",
      },
      messaging: {
        title: "WhatsApp y correo",
        text: "Notificaciones que mantienen informados a los implicados sobre la reserva y el check-in.",
      },
    },
    testimonials: {
      title: "Selfie Check-in ya forma parte de la rutina de quien hospeda",
      lead: "Más organización para quien recibe, más cuidado con quien llega. Mira cómo Selfie Check-in puede simplificar la rutina y dejar espacio para lo que importa: recibir bien.",
      feature: "Menos tareas manuales en la gestión de los alojamientos.",
      mario: {
        name: "Mario Costa",
        role: "Anfitrión de apartamentos de temporada",
        quote: "“Antes tenía que pedir documentos y seguir cada dato por WhatsApp. Con Selfie Check-in el huésped envía todo por el formulario y puedo ver qué falta antes de la llegada. Mi rutina quedó mucho más organizada.”",
      },
      rafael: {
        name: "Rafael Almeida",
        role: "Administrador de inmuebles de temporada",
        quote: "“Una de las partes más laboriosas era coordinar la llegada con la recepción. Con Selfie, la información de la reserva llega a los implicados tras la aprobación. Eso facilitó la comunicación y redujo el ir y venir de mensajes.”",
      },
      bruna: {
        name: "Bruna Martins",
        role: "Anfitriona de casas de vacaciones",
        quote: "“Los huéspedes suelen tener dudas parecidas sobre el inmueble. Tener una guía y el apoyo de la IA en la atención me ayuda a responderlas y a dedicar más atención a las situaciones que me necesitan.”",
      },
    },
    faq: {
      eyebrow: "Preguntas frecuentes",
      title: "Preguntas que todo anfitrión hace",
      q1: {
        question: "¿Cómo funciona el check-in digital para el huésped?",
        answer: "El huésped recibe un enlace y completa un formulario con sus datos, documentos y una selfie antes de llegar. La operación sigue el envío y la validación de la información para preparar la entrada.",
      },
      q2: {
        question: "¿Cómo ayuda Selfie Check-in a validar la identidad de los huéspedes?",
        answer: "La plataforma reúne la revisión del documento, la comparación facial con la selfie y las consultas disponibles según la configuración contratada. Esa información apoya el análisis y la decisión del anfitrión.",
      },
      q3: {
        question: "¿Qué puede responder el agente de IA y cuándo pasa la atención a una persona?",
        answer: "El agente puede apoyar el llenado del check-in y responder dudas usando la información del inmueble. Cuando la situación exige atención humana, deriva la conversación al equipo responsable.",
      },
      q4: {
        question: "¿La plataforma se integra con mi sistema de reservas, la recepción y las cerraduras inteligentes?",
        answer: "Selfie Check-in ofrece integraciones para conectar esas etapas de la operación. La compatibilidad con los sistemas que usas y las posibilidades de automatización se verifican durante la implantación.",
      },
      q5: {
        question: "¿Cómo funcionan la garantía y la firma electrónica?",
        answer: "La plataforma permite incorporar la garantía al recorrido y formalizar documentos del alojamiento con firma electrónica. Los medios de pago, las condiciones de la garantía y las reglas de liberación se definen en la configuración de la operación.",
      },
      q6: {
        question: "¿Qué necesito para empezar a usar Selfie Check-in en mis inmuebles?",
        answer: "Ponte en contacto con el equipo para conocer la plataforma y presentar tu operación. En la implantación se alinean el registro de los inmuebles, los recursos contratados y las integraciones compatibles con los sistemas que ya usas.",
      },
    },
    footer: {
      home: "Inicio",
      about: "Nosotros",
      plans: "Planes",
      contact: "Contacto",
      addressLine1: "Rua Tupi - Nº228, Santa Cecília, São Paulo - SP, Brasil",
      addressLine2: "CP 01233-000 {'|'} CNPJ 56.107.848/0001-79",
      terms: "Términos y Condiciones de Uso",
      imageTerms: "Términos de Uso / Términos de Uso de la Imagen",
    },
  },
};

export default es;
